/**
 * Operator-facing labels — collection manager review disposition UI (Slice D).
 */

import type { CollectionManagerReviewDeferReasonCode } from '@shared/collection/collection-manager-review-disposition-types';

export const COLLECTION_MANAGER_REVIEW_OPERATOR_LABELS = {
  reviewSectionTitle: '예외별 검토 상태',
  acknowledgedBadge: '검토됨',
  acknowledgedAt: '검토 확인 시각',
  deferredBadge: '보류',
  deferredUntil: '보류 만료',
  deferReason: '보류 사유',
  acknowledgeAction: '검토 확인',
  acknowledgeSubmitting: '확인 중…',
  deferAction: '보류',
  deferSubmitting: '보류 중…',
  cancelDeferAction: '보류 해제',
  cancelDeferSubmitting: '해제 중…',
  deferModalTitle: '예외 알림 보류',
  deferModalBody:
    '해당 예외 알림만 지정 시점까지 숨깁니다. CollectionCase 상태는 변경되지 않으며 AR/채무 상태도 변경되지 않습니다.',
  deferReasonLabel: '보류 사유',
  deferReasonPlaceholder: '사유 선택',
  deferExpiryLabel: '보류 만료 시각',
  deferExpiryPlaceholder: '만료 시각 선택',
  deferNotesLabel: '메모 (선택)',
  deferNotesPlaceholder: '추가 메모',
  deferConfirm: '보류 적용',
  deferCancel: '취소',
  deferValidationReason: '보류 사유를 선택해 주세요.',
  deferValidationExpiry: '만료 시각을 선택해 주세요.',
  deferValidationExpiryFuture: '만료 시각은 현재 이후여야 합니다.',
  deferValidationNotesOther: '기타 사유는 메모가 필요합니다.',
  deferValidationNotesLength: '메모는 500자 이내로 입력해 주세요.',
  staleSourceMessage: '예외 정보가 변경되었습니다. 최신 상태를 불러온 뒤 다시 시도해 주세요.',
  inactiveExceptionMessage: '해당 예외는 더 이상 활성 상태가 아닙니다. 목록을 새로고침합니다.',
  idempotencyConflictMessage: '동일 요청이 처리 중입니다. 잠시 후 다시 시도해 주세요.',
  mutationFailed: '요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.',
  permissionAcknowledgeDenied: '검토 확인 권한이 없습니다.',
  permissionDeferDenied: '보류 권한이 없습니다.',
  includeDeferredFilter: '보류 항목 포함',
  includeDeferredHint: '보류 중인 예외 플래그도 목록에 표시합니다.',
  emptyDeferredHint: '보류 중인 항목이 없습니다.',
  refreshAfterMutation: '목록 새로고침',
  fingerprintMissing: '검토 대상 식별 정보가 없어 조치할 수 없습니다.',
  forbiddenCopyApprove: '승인',
  forbiddenCopyResolve: '해결',
  forbiddenCopyApproved: '승인됨',
  forbiddenCopyResolved: '해결됨',
  notesMaxLength: 500,
} as const;

const DEFER_REASON_LABELS: Record<CollectionManagerReviewDeferReasonCode, string> = {
  awaiting_customer_response: '고객 응답 대기',
  pending_internal_review: '내부 검토 대기',
  scheduled_follow_up: '예정된 후속 조치',
  operator_capacity: '운영자 처리 용량',
  other: '기타',
};

export function labelManagerReviewDeferReason(
  code: CollectionManagerReviewDeferReasonCode
): string {
  return DEFER_REASON_LABELS[code] ?? code;
}

export function formatManagerReviewTimestamp(iso: string | undefined): string {
  if (!iso?.trim()) {
    return '—';
  }
  const parsed = Date.parse(iso);
  if (Number.isNaN(parsed)) {
    return iso;
  }
  return new Intl.DateTimeFormat('ko-KR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(parsed));
}

export const COLLECTION_MANAGER_REVIEW_OPERATOR_FORBIDDEN_COPY = [
  COLLECTION_MANAGER_REVIEW_OPERATOR_LABELS.forbiddenCopyApprove,
  COLLECTION_MANAGER_REVIEW_OPERATOR_LABELS.forbiddenCopyResolve,
  COLLECTION_MANAGER_REVIEW_OPERATOR_LABELS.forbiddenCopyApproved,
  COLLECTION_MANAGER_REVIEW_OPERATOR_LABELS.forbiddenCopyResolved,
] as const;
